import React from 'react';
import { useDispatch } from 'react-redux';
import { catalogLayoutSlice } from 'src/features/catalog';

export const MAP_MARKER_CLICK_HANDLER_NAME = '__handleMapMarkerClick';

export const useMapMarkerClickHandler = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    window[MAP_MARKER_CLICK_HANDLER_NAME] = (catalogItemId: number, event: PointerEvent) => {
      event.stopPropagation?.();
      event.preventDefault?.();
      dispatch(catalogLayoutSlice.actions.setActiveItem(catalogItemId));
    };

    return () => {
      delete window[MAP_MARKER_CLICK_HANDLER_NAME];
    };
  }, [dispatch]);
};
